import { CSSProperties } from 'react';

import { Icon, Progress } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { AIChatAttachment } from '@atom/types/ai';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import classes from './chat.module.css';

type ChatAttachmentPreviewProps = {
  attachment: AIChatAttachment;
  onRemove: () => void;
};

const styles: Record<string, CSSProperties> = {
  removeIcon: {
    fontSize: fonts.lg,
    color: colors.neutral.gray,
  },
  errorIcon: {
    fontSize: fonts.xxxl,
    color: colors.neutral.gray,
  },
};

const ChatAttachmentPreview = ({
  attachment,
  onRemove,
}: ChatAttachmentPreviewProps) => {
  const isUploading = attachment.status === 'uploading';
  const isError = attachment.status === 'error';
  const imageStyle = attachment.fileId
    ? {
        backgroundImage: `url('${FILES_ENDPOINT}/${attachment.fileId}_180')`,
      }
    : {};

  const getStatus = () => {
    if (isUploading) {
      return <Progress size={20} thickness={3} />;
    }

    if (isError) {
      return (
        <div className={classes.attachmentError}>
          <Icon style={styles.errorIcon}>error</Icon>
        </div>
      );
    }

    return <div className={classes.attachmentThumbnail} style={imageStyle} />;
  };

  return (
    <div className={classes.attachmentChip}>
      {getStatus()}
      <button className={classes.attachmentRemoveButton} onClick={onRemove}>
        <Icon style={styles.removeIcon}>cancel</Icon>
      </button>
    </div>
  );
};

export default ChatAttachmentPreview;
